export default function ValidationMessageList({ title, items, tone = "error" }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  const cls = tone === "warning"
    ? "border-amber-200 bg-amber-50 text-amber-800"
    : "border-rose-200 bg-rose-50 text-rose-800";

  return (
    <div className={`rounded-lg border p-2 text-xs ${cls}`}>
      <p className="mb-1 font-semibold">{title}</p>
      <ul className="list-disc pl-4">
        {items.slice(0, 3).map((item, index) => (
          <li key={`${title}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
}
